// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock .right {
  width: 100%;
  /* border: 1px solid pink; */
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  /* justify-content: space-between !important; */
  justify-content: flex-start !important;
 
  padding: 0px !important;
  cursor: auto;
  gap: 10px;
}
 
.stock .middle {
  /* border: 1px solid rgb(207, 255, 192) !important; */
  display: flex !important;
  flex-direction: column !important;
  /* align-items: flex-start !important; */
  justify-content: flex-start !important;
  /* justify-content: space-between !important; */
  padding: 0px !important;
  padding-right: 15px !important;
  gap: 14px;
}
 
.stock .content {
  display: flex;
  /* width: 50%; */
  align-items: flex-start;
  justify-items: center;
 
  /* height: 40px; */
  /* border: 1px solid yellowgreen; */
}
 
.stock .content-new {
  display: flex;
  /* width: 50%; */
  align-items: center !important;
  justify-content: center !important;
  /* width: 100%; */
  /* height: 100%; */
  /* border: 1px solid red; */
  /* margin: auto; */
}
 
.stock .content-new-0 {
  display: flex;
  /* width: 50%; */
  align-items: flex-start;
  justify-items: center;
 
  /* height: 40px; */
  /* border: 1px solid yellowgreen; */
}
 
.stock .newIcon {
  display: flex;
  /* width: 50%; */
  align-items: flex-start;
  justify-content: center;
 
  /* height: 40px; */
  /* border: 1px solid yellowgreen; */
}
 
.stock .content-typo {
  display: flex;
  align-items: center;
  /* height: 40px; */
  font-family: karla !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 22px !important ;
  /* border: 1px solid rgb(0, 255, 115); */
}
 
.stock .content-typo-0 {
  display: flex;
  align-items: center;
  /* height: 40px; */
  font-family: karla !important;
  font-size: 18px !important;
  font-weight: 500;
  line-height: 22px !important;
  /* border: 1px solid rgb(38, 0, 255); */
}
 
.stock .content .btn {
  margin-left: auto;
}
 
.stock .left {
  position: relative;
  /* display: inline-block; */
  width: 100%;
}
.stock .left img {
  display: block;
  /* width: 150px;
    height: 153px; */
  width: 100%;
  height: 100%;
  /* border: 1px solid rgb(98, 0, 255); */
}
 
.stock .left .hoverCheck {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  border-radius: 5px;
  display: none; /* Initially hidden */
  /* border: 1px solid red; */
  /* appearance: none; */
}
 
/* Show the checkbox when hovering over the parent */
.stock .left.hover-enabled:hover .hoverCheck {
  display: block;
}
 
/* Keep the checkbox visible when checked */
.stock .left .hoverCheck.Mui-checked {
  display: block;
}
 
.stock .left button {
  position: absolute;
  bottom: 1px;
  left: 50%;
 
  transform: translateX(-50%);
  background-color: "#FFFFFF";
  color: #50c878;
  font-weight: 500;
  font-size: 18px;
  text-transform: none;
  padding: 2px;
  border-radius: 5px;
  height: 40px;
  width: 110px;
  text-align: center;
}
 
.createproject {
  position: fixed;
  background: #fff;
  color: #000;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0.5vw 0.3vw;
  z-index: 1000;
  cursor: pointer;
  height: auto;
  width: 14vw;
  /* width: 151px; */
  font-family: karla;
  font-weight: 500;
  font-size: 1vw;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-items: center;
   justify-content: flex-start;
   
}
.createproject:hover {
  height: auto;
  font-size: 0.92vw;
}
 
.createproject-inner {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* gap: 5px; */
  gap: 0.3vw;
  border-radius: 4px;
  text-wrap: nowrap;
  /* height: 32px; */
  height: 3.6vh;
  /* width: 141px; */
  /* width: 13.8vw; */
  width: 13.8vw;
  padding: 0.3vw; 
}
 
.createproject-inner:hover {
  background: #444444;
  color: #fff;
  border-color: #000;
}
 
.createproject-inner:hover svg {
  color: white !important; /* on hover */
  fill: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/features/Stock/StockProd/components/product.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,4BAA4B;EAC5B,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,+CAA+C;EAC/C,sCAAsC;;EAEtC,uBAAuB;EACvB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,wBAAwB;EACxB,iCAAiC;EACjC,wCAAwC;EACxC,sCAAsC;EACtC,+CAA+C;EAC/C,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;;EAErB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;;EAErB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;;EAEvB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,cAAc;EACd;oBACkB;EAClB,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa,EAAE,qBAAqB;EACpC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;EACE,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;;EAET,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;GAClB,2BAA2B;;AAE9B;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uBAAuB,EAAE,aAAa;EACtC,qBAAqB;AACvB","sourcesContent":[".stock .right {\n  width: 100%;\n  /* border: 1px solid pink; */\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  /* justify-content: space-between !important; */\n  justify-content: flex-start !important;\n \n  padding: 0px !important;\n  cursor: auto;\n  gap: 10px;\n}\n \n.stock .middle {\n  /* border: 1px solid rgb(207, 255, 192) !important; */\n  display: flex !important;\n  flex-direction: column !important;\n  /* align-items: flex-start !important; */\n  justify-content: flex-start !important;\n  /* justify-content: space-between !important; */\n  padding: 0px !important;\n  padding-right: 15px !important;\n  gap: 14px;\n}\n \n.stock .content {\n  display: flex;\n  /* width: 50%; */\n  align-items: flex-start;\n  justify-items: center;\n \n  /* height: 40px; */\n  /* border: 1px solid yellowgreen; */\n}\n \n.stock .content-new {\n  display: flex;\n  /* width: 50%; */\n  align-items: center !important;\n  justify-content: center !important;\n  /* width: 100%; */\n  /* height: 100%; */\n  /* border: 1px solid red; */\n  /* margin: auto; */\n}\n \n.stock .content-new-0 {\n  display: flex;\n  /* width: 50%; */\n  align-items: flex-start;\n  justify-items: center;\n \n  /* height: 40px; */\n  /* border: 1px solid yellowgreen; */\n}\n \n.stock .newIcon {\n  display: flex;\n  /* width: 50%; */\n  align-items: flex-start;\n  justify-content: center;\n \n  /* height: 40px; */\n  /* border: 1px solid yellowgreen; */\n}\n \n.stock .content-typo {\n  display: flex;\n  align-items: center;\n  /* height: 40px; */\n  font-family: karla !important;\n  font-size: 16px !important;\n  font-weight: 400 !important;\n  line-height: 22px !important ;\n  /* border: 1px solid rgb(0, 255, 115); */\n}\n \n.stock .content-typo-0 {\n  display: flex;\n  align-items: center;\n  /* height: 40px; */\n  font-family: karla !important;\n  font-size: 18px !important;\n  font-weight: 500;\n  line-height: 22px !important;\n  /* border: 1px solid rgb(38, 0, 255); */\n}\n \n.stock .content .btn {\n  margin-left: auto;\n}\n \n.stock .left {\n  position: relative;\n  /* display: inline-block; */\n  width: 100%;\n}\n.stock .left img {\n  display: block;\n  /* width: 150px;\n    height: 153px; */\n  width: 100%;\n  height: 100%;\n  /* border: 1px solid rgb(98, 0, 255); */\n}\n \n.stock .left .hoverCheck {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 24px;\n  height: 24px;\n  border-radius: 5px;\n  display: none; /* Initially hidden */\n  /* border: 1px solid red; */\n  /* appearance: none; */\n}\n \n/* Show the checkbox when hovering over the parent */\n.stock .left.hover-enabled:hover .hoverCheck {\n  display: block;\n}\n \n/* Keep the checkbox visible when checked */\n.stock .left .hoverCheck.Mui-checked {\n  display: block;\n}\n \n.stock .left button {\n  position: absolute;\n  bottom: 1px;\n  left: 50%;\n \n  transform: translateX(-50%);\n  background-color: \"#FFFFFF\";\n  color: #50c878;\n  font-weight: 500;\n  font-size: 18px;\n  text-transform: none;\n  padding: 2px;\n  border-radius: 5px;\n  height: 40px;\n  width: 110px;\n  text-align: center;\n}\n \n.createproject {\n  position: fixed;\n  background: #fff;\n  color: #000;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 0.5vw 0.3vw;\n  z-index: 1000;\n  cursor: pointer;\n  height: auto;\n  width: 14vw;\n  /* width: 151px; */\n  font-family: karla;\n  font-weight: 500;\n  font-size: 1vw;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  align-items: center;\n   justify-content: flex-start;\n   \n}\n.createproject:hover {\n  height: auto;\n  font-size: 0.92vw;\n}\n \n.createproject-inner {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  /* gap: 5px; */\n  gap: 0.3vw;\n  border-radius: 4px;\n  text-wrap: nowrap;\n  /* height: 32px; */\n  height: 3.6vh;\n  /* width: 141px; */\n  /* width: 13.8vw; */\n  width: 13.8vw;\n  padding: 0.3vw; \n}\n \n.createproject-inner:hover {\n  background: #444444;\n  color: #fff;\n  border-color: #000;\n}\n \n.createproject-inner:hover svg {\n  color: white !important; /* on hover */\n  fill: #fff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
